import { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { capitalize, Icon, IconButton } from "@mui/material";
import { T } from "components/alove/Translator";
import { getMMList, updateMM, updateMMFeatured,  updateFeaturedMMOrder } from "utils/matchmakerUtils";
import { TablePage } from "components/alove/TablePage";
import { getSMEStats } from "utils/matchmakerUtils";
import { TwoSizeChip } from "components/alove/Chips";
import { getStatusColor, MMStatuses } from "models/BO/Matchmaker";
import { GridColDef } from "@mui/x-data-grid-pro";
import { useMaterialUIController } from "context";
import { PermissionType } from "models/BO/BoRole";
import { PageNumber } from "../../../accessNumbers";
import { addAlert } from "context";

const MDAvatar = require("components/MDAvatar").default;
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { formatDate } from "utils/globalsUtils";
const DashboardNavbar = require("examples/Navbars/DashboardNavbar/index.js").default;

function SMEProfiles() {
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = controller;
  const [stats, setStats] = useState({
    mmTotal: 0,
    mmActive: 0,
    mmPending: 0,
    mmWarning: 0,
  });
  const [reorderMode, setReorderMode] = useState(false);
  const [featuredRows, setFeaturedRows] = useState<any[]>([]);
  const columns: GridColDef[] = [
    {
      headerName: "",
      field: "avatar",

      align: "center",
      renderCell: (params) => (
        <Grid container alignItems="center" height="100%">
          <MDAvatar src={params?.row?.user?.avatar} />
        </Grid>
      ),
    },
    { headerName: "firstNameHeader", field: "first_name", flex: 1, valueGetter: (v, row) => row.user?.firstName },
    { headerName: "lasNameHeader", field: "last_name", flex: 1, valueGetter: (v, row) => row.user?.lastName },
    { headerName: "emailHeader", field: "email", flex: 1, valueGetter: (v, row) => row.user?.email },
    { headerName: "phoneHeader", field: "phone", flex: 1, valueGetter: (v, row) => row.user?.phone },
    { headerName: "Joined", field: "joined", flex: 1, valueGetter: (v, row) => formatDate(row.user?.created) },
    { headerName: "Last Active", field: "lastActive", flex: 1, valueGetter: (v, row) => formatDate(row.user?.lastActive) },
    {
      headerName: "status",
      field: "status",
      flex: 1,
      align: "center",

      renderCell: (params) => (
        <TwoSizeChip
          sizeoption={params.row.profileStatus == MMStatuses.pending ? "wide" : "narrow"}
          label={<T>smeStatus{params.row.profileStatus}</T>}
          color={getStatusColor(params.row.profileStatus) as any}
        />
      ),
    },
    { headerName: "featured", field: "featured", align: "center", renderCell: (params) => (
      <IconButton onClick={(e) => {
        e.stopPropagation();
        updateMMFeatured(params.row.id)
           params.api.updateRows([{
          ...params.row,
          attributes: {
            ...params.row.attributes,
            featured: !params.row.attributes.featured
          }
        }]);
          
      }}>
        {params.row.attributes.featured ? <Icon>star</Icon> : <Icon>star_border</Icon>}
      </IconButton>
    )
    
     },
    { headerName: "requests", field: "requests", align: "center" },
    {
      headerName: "",

      align: "center",
      field: "actions",
      renderCell: (params) => <Icon>edit</Icon>,
    },
  ];
  const navigate = useNavigate();

  const getSMEUsers = async (filters, page) => {
    
    const SMEUsers = await getMMList({
      statusFilter: filters["status"],
      user: filters["search"],
      featured: reorderMode,
      page,
      withDeleted: currentRole.hasAccess(PageNumber.SMEProfiles, PermissionType.Manager),
    });
    ;
    if (reorderMode) {
      SMEUsers.sort((a, b) => b.attributes.featured - a.attributes.featured);
      setFeaturedRows(SMEUsers);
    }
    return SMEUsers.map((item, index) => ({
      ...item,
      profileStatus: item.status,
      requests: `${item.activeRequests || 0}/${item.totalRequests || 0}`,
    }));
  };

  const handleReorderFeatured = async () => {
    setReorderMode(true);
  };

  const handleSaveOrder = async () => {
    try {
      const ids = featuredRows.map(row => row.id);
      await updateFeaturedMMOrder(ids);
      addAlert(dispatch, "Featured SME order saved successfully");
      setReorderMode(false);
      setFeaturedRows([]);
    } catch (error) {
      console.error("Error saving order:", error);
      addAlert(dispatch, "Failed to save order", true);
    }
  };

  const handleCancelReorder = () => {
    setReorderMode(false);
    setFeaturedRows([]);
  };

  const onRowOrderChange = (params) => {
    if (reorderMode) {
      const updatedRows = [...featuredRows];
      const [movedRow] = updatedRows.splice(params.oldIndex, 1);
      updatedRows.splice(params.targetIndex, 0, movedRow);
      setFeaturedRows(updatedRows);
    }
  };

  useEffect(() => {
    getSMEStats().then((data) => {
      setStats(data);
    });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle="SME Profiles" />
      <TablePage
        title="SME List"
        table={{
          columns: columns,
          loadNext: getSMEUsers,
          rowCount: stats.mmTotal,
          lineClick: reorderMode ? undefined : (row) => navigate(row.id.toString()),
          onRowOrderChange: reorderMode ? onRowOrderChange : undefined,
          
        }}
        rerenderKey={JSON.stringify(featuredRows)}
        refresh={reorderMode}
        filters={reorderMode ? [] : [
          {
            label: "search",
            type: "search",
            placeholder:"Name, Email, Phone",
          },
          {
            label: "status",
            options: Object.keys(MMStatuses)
              .filter((key) => !isNaN(Number(key)))
              .map((key) => ({
                key,
                label: capitalize(MMStatuses[key]),
              })),
          }
        ]}
        actions={reorderMode ? {
          title: "Reorder Actions",
          saveActions: [
            {
              label: "Save Order",
              variant: "contained",
              onClick: handleSaveOrder,
            },
            {
              label: "Cancel",
              variant: "outlined",
              onClick: handleCancelReorder,
            },
          ],
        } : {
          title: "SME Actions",
          addActions: [
            {
              label: "Reorder Featured",
              variant: "outlined",
              onClick: handleReorderFeatured,
            },
          ],
        }}
        stats={reorderMode ? undefined : {
          title: "SMEStats",
          stats: stats,
          fields: [
            {
              name: "mmTotal",
              title: "totalSME",
              color: "primary",
              filterLabel: "status",
              filterValue: "",
            },
            {
              name: "mmActive",
              title: "activeSME",
              filterLabel: "status",
              filterValue: MMStatuses.available.toString(),
            },
            {
              name: "mmPending",
              title: "pendingSME",
              filterLabel: "status",
              filterValue: MMStatuses.pending.toString(),
            },
            {
              name: "mmWarning",
              title: "warning",
              color: "error",
            },
          ],
        }}
      />
    </DashboardLayout>
  );
}

export default SMEProfiles;
